<template>
	<!-- Mobile header and menu -->
	<div class="w-full md:hidden flex items-center justify-between p-6 mobile-header-bg rounded-t-2xl">
		<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkLogo : lightLogo" alt="Logo" class="w-36 h-auto md:w-44"/>
		<div class="flex items-center space-x-2">
			<button @click="$emit('toggleMobileMenu')" class="text-[var(--text-color)] p-2">
				<svg v-if="!isMobileMenuOpen" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
				</svg>
				<svg v-else xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
				</svg>
			</button>
		</div>
	</div>

	<div v-if="isMobileMenuOpen" class="md:hidden absolute inset-0 top-0 left-0 w-full h-full sidemenu-bg rounded-2xl z-50 overflow-y-auto custom-scrollbar">
		<div class="w-full flex items-center justify-between p-6 mobile-header-bg rounded-t-2xl">
			<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkLogo : lightLogo" alt="Logo" class="w-36 h-auto md:w-44"/>
			<button @click="$emit('closeMobileMenu')" class="text-[var(--text-color)] p-2">
				<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
				</svg>
			</button>
		</div>

		<hr class="w-full border-[var(--border-color)]">

		<div class="flex flex-col items-center mx-auto space-y-6 w-[80%] my-6">
			<div v-if="!btcOnly" ref="mobileDropdownRef" class="w-full relative">
				<button @click.stop="$emit('toggleChainDropdown')" class="flex items-center w-full p-2 font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] rounded-lg transition duration-100">
					<img :src="selectedChain.icon" alt="Chain Icon" class="w-6 h-6 ml-2" />
					<span class="flex-1 ml-2">{{ selectedChain.name }}</span>
					<svg :class="{'rotate-180 transform': chainDropdownOpen}" class="w-4 h-4 transition-transform duration-100" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
					</svg>
				</button>
				<transition name="fade">
					<div v-if="chainDropdownOpen"  @click.stop class="absolute left-0 right-0 mt-1 bg-[var(--dropdown-bg-color)] rounded-lg shadow-lg z-30 overflow-hidden">
						<button v-for="chain in displayedChains" :key="chain.name" @click="$emit('selectChain', chain); $emit('backToOverview')" class="flex items-center w-full p-2 font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] hover:rounded-lg hover:text-[var(--hover-text-color)] transition duration-100">
							<img :src="chain.icon" :alt="chain.name" class="w-6 h-6 mr-3" />
							<span class="flex-1">{{ chain.name }}</span>
						</button>
					</div>
				</transition>
			</div>
			<!-- NEW ACCOUNT BUTTON -->
			<div @click="$emit('openAccountView'); $emit('closeMobileMenu')" class="flex items-center p-2 w-full font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkAccountIcon : lightAccountIcon" alt="Account" class="w-6 h-6 mr-2 ml-2"/>
				Account
			</div>
			<button @click="$emit('backToOverview'); $emit('closeMobileMenu')" class="flex items-center p-2 w-full font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkWallet : lightWallet" alt="Logo" class="w-6 h-6 mr-2 ml-2"/>
				Wallet
			</button>
			<div v-if="!btcOnly && selectedChain.name !== 'Bitcoin'" @click="$emit('openTradeView'); $emit('closeMobileMenu')" class="flex items-center p-2 w-full font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkWC : lightWC" alt="Logo" class="w-6 h-6 mr-2 ml-2"/>
				WalletConnect
			</div>
			<div v-if="selectedChain.name == 'Bitcoin'" @click="$emit('showComingSoonMessage')" class="flex items-center p-2 w-full font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkMultisig : lightMultisig" alt="Multisig" class="w-6 h-6 mr-2 ml-2"/>
				Multisig
			</div>
			<div @click="$emit('showExportZpubView'); $emit('closeMobileMenu')" class="flex items-center p-2 w-full font-archivoregular text-left text-[var(--secondary-text-color)] cursor-pointer hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkExport : lightExport" alt="Wallet Icon" class="w-6 h-6 mr-2 ml-2"/>
				Export zPub
			</div>
			<div @click="$emit('showThemePopup')" class="flex items-center p-2 w-full font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkSettings : lightSettings" alt="Logo" class="w-6 h-6 mr-2 ml-2"/>
				Theme
			</div>
			<div @click="$emit('showResourcesPopup')" class="flex items-center p-2 w-full font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkResources : lightResources" alt="Logo" class="w-6 h-6 mr-2 ml-2"/>
				Resources
			</div>
			<div @click="$emit('unpairWallet')" class="flex items-center p-2 w-full text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkUnpair : lightUnpair" alt="Logo" class="w-6 h-6 mr-2 ml-2"/>
				Unpair
			</div>
		</div>
	</div>

	<!-- Desktop (side-menu) -->
	<div class="hidden md:flex md:w-1/4 lg:w-1/5 md:h-full md:flex-col md:items-start sidemenu-bg p-6 rounded-l-2xl relative">
		<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkLogo : lightLogo" alt="Logo" class="mb-4 w-48 h-auto md:relative md:left-3 md:top-3 md:pr-6"/>
		<hr class="w-full mb-2 mt-4 border-[var(--border-color)]">

		<!-- Chain Dropdown -->
		<div v-if="!btcOnly" ref="desktopDropdownRef" class="w-full">
			<div class="relative mb-2 w-full">
				<button @click.stop="$emit('toggleChainDropdown')" :class="['flex items-center mx-auto p-2 px-4 w-full font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100', { 'animate-pulse ring-2 ring-[var(--accent-color)]': highlightChain }]">
					<img :src="selectedChain.icon" alt="Chain Icon" class="w-6 h-6 md:mr-2 lg:mr-4"/>
						{{ selectedChain.name }}
					<svg class="ml-auto w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path>
					</svg>
				</button>
				<div v-if="chainDropdownOpen" @click.stop class="absolute left-0 mt-1 w-full bg-[var(--dropdown-bg-color)] rounded-lg shadow-lg z-50">
					<button v-for="chain in displayedChains" :key="chain.name" @click="$emit('selectChain', chain); $emit('backToOverview')" class="flex items-center p-2 px-3 w-full font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] rounded-lg transition duration-100">
					<img :src="chain.icon" :alt="chain.name" class="w-6 h-6 mr-4"/>
						{{ chain.name }}
					</button>
				</div>
			</div>
			<hr class="w-full mb-2 border-[var(--border-color)]">
		</div>
		<!-- NEW ACCOUNT BUTTON -->
		<div @click="$emit('openAccountView')" class="flex items-center mb-2 p-2 w-full font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100">
			<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkAccountIcon : lightAccountIcon" alt="Account" class="w-6 h-6 mr-4"/>
			Account
		</div>
		<button @click="$emit('backToOverview')" class="flex items-center mb-2 p-2 w-full font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100 z-40">
			<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkWallet : lightWallet" alt="Wallet Icon" class="w-6 h-6 mr-4"/>
			Wallet
		</button>
		<!-- ─── Send Button ─────────────────────────────────────────────────── -->
		<button @click="$emit('openSendView')" class="flex items-center mb-2 p-2 w-full font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100 z-40">
			<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkSend : lightSend" alt="Send Icon" class="w-6 h-6 mr-4"/>
			Send
		</button>
		<button @click="$emit('showReceiveView')" class="flex items-center mb-2 p-2 w-full font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100 z-40">
			<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkReceive : lightReceive" alt="Receive Icon" class="w-6 h-6 mr-4" />
			Receive
		</button>
		<div  v-if="!btcOnly && selectedChain.name !== 'Bitcoin'" @click="$emit('openTradeView')" class="flex items-center mb-2 p-2 w-full font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100 z-40">
			<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkWC : lightWC" alt="Trade Icon" class="w-6 h-6 mr-4"/>
			WalletConnect
		</div>
		<div v-if="selectedChain.name == 'Bitcoin'" @click="$emit('showComingSoonMessage')" class="flex items-center mb-2 p-2 w-full font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100 z-40">
			<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkMultisig : lightMultisig" alt="Multisig" class="w-6 h-6 mr-4"/>
			Multisig
		</div>
		<div @click="$emit('showExportZpubView')" class="flex items-center mb-2 p-2 w-full font-archivoregular text-left text-[var(--secondary-text-color)] cursor-pointer hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100 z-40">
			<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkExport : lightExport" alt="Wallet Icon" class="w-6 h-6 mr-4"/>
			Export zPub
		</div>
		<div @click="$emit('showThemePopup')" class="flex items-center mb-2 p-2 w-full font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100 z-40">
			<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkSettings : lightSettings" alt="Theme" class="w-6 h-6 mr-4"/>
			Theme
		</div>
		<div @click="$emit('showResourcesPopup')" class="flex items-center mb-2 p-2 w-full font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100 z-40">
			<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkResources : lightResources" alt="Resources" class="w-6 h-6 mr-4"/>
			Resources
		</div>
		<!-- bottom of columnn -->
		<div @click="$emit('unpairWallet')" class="flex items-center mt-auto mb-2 p-2 w-full font-archivoregular text-left text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] rounded-lg hover:text-[var(--hover-text-color)] transition duration-100 z-40">
			<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkUnpair : lightUnpair" alt="Unpair" class="w-6 h-6 mr-4"/>
			Unpair
		</div>
	</div>
</template>

<script setup>
	import { ref, onMounted, onBeforeUnmount } from 'vue';
	import lightLogo from '../assets/CWWLogo.png';
	import darkLogo from '../assets/LogoWhite1.png';
	import lightWallet from '../assets/5Wallet.png';
	import darkWallet from '../assets/WalletWhite1.png';
	import lightWC from '../assets/wcLogoLightTheme.png';
	import darkWC from '../assets/wcLogoDarkTheme.png';
	import lightSettings from '../assets/SettIcon.png';
	import darkSettings from '../assets/SettingsWhite.png';
	import lightResources from '../assets/Resources.png';
	import darkResources from '../assets/ResourcesWhite.png';
	import lightMultisig from '../assets/Light_Theme_Multisig.png';
	import darkMultisig from '../assets/Dark_Theme_Multisig.png';
	import lightExport from '../assets/ExportLightTheme.png';
	import darkExport from '../assets/ExportDarkTheme.png';
	import lightUnpair from '../assets/Unpair.png';
	import darkUnpair from '../assets/UnpairWhite1.png';
	import lightSend from '../assets/SendIconLightTheme.png';
	import darkSend  from '../assets/SendIconDarkTheme.png';
	import lightReceive from '../assets/ReceiveIconLightTheme.png'
	import darkReceive from '../assets/ReceiveIconDarkTheme.png'
	import lightAccountIcon from '../assets/lightAccountIcon.png';
	import darkAccountIcon from '../assets/darkAccountIcon.png';

	const props = defineProps({
		currentTheme: { type: String, required: true },
		btcOnly: { type: Boolean, required: true },
		highlightChain: { type: Boolean, required: false },
		isMobileMenuOpen: { type: Boolean, required: true },
		chainDropdownOpen: { type: Boolean, required: true },
		displayedChains: { type: Array,   required: true },
		selectedChain: { type: Object,  required: true },
	});

	const emit = defineEmits([
		'toggleMobileMenu',
		'closeMobileMenu',
		'toggleChainDropdown',
		'selectChain',
		'backToOverview',
		'openTradeView',
		'showThemePopup',
		'showResourcesPopup',
		'showComingSoonMessage',
		'showExportZpubView',
		'unpairWallet',
		'openSendView',
		'showReceiveView',
		'openAddTokenPopup',
		'openAccountView',
	]);

	// these refs point at the two dropdown containers
	const mobileDropdownRef  = ref(null);
	const desktopDropdownRef = ref(null);

	// when open, if click is anywhere outside both dropdown refs, close it
	function onClickOutside(event) {
		if (!props.chainDropdownOpen) return;

		const inMobile  = mobileDropdownRef.value?.contains(event.target);
		const inDesktop = desktopDropdownRef.value?.contains(event.target);

		if (!inMobile && !inDesktop) {
			emit('toggleChainDropdown');
		}
	}

	onMounted(() => {
		document.addEventListener('click', onClickOutside);
	});
	onBeforeUnmount(() => {
		document.removeEventListener('click', onClickOutside);
	});
</script>

<style scoped>
	.sidemenu-bg {
		background: var(--sidemenu-bg-color);
	}

	.mobile-header-bg {
		background: var(--mobile-header-bg-color);
	}
</style>
